import React from 'react';
import { 
  AdminKpiGrid,
  UserStatistics,
  SystemActivity,
  ActivityLog,
  ProjectStatistics,
  ResourceUsage,
  ServiceStatus,
  SystemAlerts,
  SystemInfo,
  AdminQuickActions
} from './components';

export default function AdminDashboardPage() {
  return (
    <div className="p-3 space-y-2 bg-slate-50/30 min-h-screen text-slate-800">
      {/* Header section manually reconstructed without Layout */}
      <div className="px-1 mb-4">
        <div className="flex items-center gap-2 text-xs font-medium text-slate-400 mb-1">
          <span>Trang chủ</span>
          <i className="ri-arrow-right-s-line" />
          <span className="text-slate-600 font-medium">Admin</span>
        </div>
        <h1 className="text-xl font-medium tracking-tight text-slate-800">Tổng quan hệ thống</h1>
      </div>

      {/* KPI Section */}
      <AdminKpiGrid />

      <div className="space-y-4">
        {/* Middle Section: Auto-fit responsive layout */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-4">
          <UserStatistics />
          <SystemActivity />
          <ActivityLog />
        </div>

        {/* Footer Section: Auto-fit responsive layout */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-4">
          <ProjectStatistics />
          <ResourceUsage />
          <ServiceStatus />
        </div>

        {/* Bottom Section: Auto-fit responsive layout */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-4">
          <SystemAlerts />
          <SystemInfo />
          <AdminQuickActions />
        </div>
      </div>
    </div>
  );
}
